module.exports = __webpack_public_path__ + "img/PHOX_FullLogo_FullColorBlue-785x400.cf8b789f.png";